/**
 * Search API Service
 *
 * @module search/services
 * @version 1.0
 *
 * @description
 * Cliente HTTP para el endpoint de búsqueda del backend.
 */

import { SearchRequest, SearchResponse } from '../types';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api/v1';

/**
 * Servicio de API de búsqueda
 */
export class SearchApiService {
  private static instance: SearchApiService;

  private constructor() {}

  public static getInstance(): SearchApiService {
    if (!SearchApiService.instance) {
      SearchApiService.instance = new SearchApiService();
    }
    return SearchApiService.instance;
  }

  /**
   * Ejecuta una búsqueda
   *
   * @param request - Request de búsqueda
   * @param token - JWT token para autenticación
   * @returns Promise con resultados de búsqueda
   */
  async search(request: SearchRequest, token: string): Promise<SearchResponse> {
    const response = await fetch(`${API_BASE_URL}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Search failed' }));
      throw new Error(error.message || `HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}

// Export singleton instance
export const searchApiService = SearchApiService.getInstance();
